import EntryValidator from '@wielink-application/shared/js/base/menu/EntryValidator';
export default EntryValidator;